<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.applicants.create.jobPosting' | translate }}</mat-label>
            <mat-select
                [disabled]="disableJobPostingSelect"
                name="jobPosting"
                #jobPosting="ngModel"
                required
                [(ngModel)]="applicant.jobPosting"
            >
                <mat-option value="">{{ 'none' | translate }}</mat-option>
                <mat-option *ngFor="let jobPosting of jobPostings" [value]="jobPosting"
                    >{{ jobPosting.title }} ({{ jobPosting.createdAt | appDate }})</mat-option
                >
            </mat-select>
            <mat-error *ngIf="jobPosting.invalid">{{ jobPosting.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>{{ 'applicant-tracker.applicants.create.firstName' | translate }}</mat-label>
            <input
                type="text"
                matInput
                name="firstName"
                [(ngModel)]="applicant.firstName"
                required
                #firstName="ngModel"
            />
            <mat-error *ngIf="firstName.invalid">{{ firstName.errors | formErrors }} </mat-error>
        </mat-form-field>
    </div>

    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>{{ 'applicant-tracker.applicants.create.lastName' | translate }}</mat-label>
            <input type="text" matInput name="lastName" [(ngModel)]="applicant.lastName" required #lastName="ngModel" />
            <mat-error *ngIf="lastName.invalid">{{ lastName.errors | formErrors }} </mat-error>
        </mat-form-field>

        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'applicant-tracker.applicants.create.email' | translate }}</mat-label>
                <input
                    data-lpignore="true"
                    type="email"
                    email
                    matInput
                    name="email"
                    [(ngModel)]="applicant.email"
                    required
                    #email="ngModel"
                />
                <mat-error *ngIf="email.invalid">{{ email.errors | formErrors }} </mat-error>
            </mat-form-field>
        </div>
    </div>

    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>{{ 'applicant-tracker.applicants.create.phone' | translate }}</mat-label>
            <input type="text" matInput name="phone" [(ngModel)]="applicant.phone" #phone="ngModel" />
            <mat-error *ngIf="phone.invalid">{{ phone.errors | formErrors }} </mat-error>
        </mat-form-field>
    </div>

    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>{{ 'applicant-tracker.applicants.create.country' | translate }}</mat-label>
            <ui-country-autocomplete
                name="country"
                #country="ngModel"
                [(ngModel)]="applicant.country"
            ></ui-country-autocomplete>
            <mat-error *ngIf="country.invalid">{{ country.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label>{{ 'applicant-tracker.applicants.create.postalCode' | translate }}</mat-label>
            <input type="text" matInput name="postalCode" #postalCode="ngModel" [(ngModel)]="applicant.postalCode" />
            <mat-error *ngIf="postalCode.invalid">{{ postalCode.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <div class="app-grid">
        <mat-form-field class="columns-4 small-columns-12">
            <mat-label appRemoveAriaOwns>{{ 'applicant-tracker.applicants.create.rating' | translate }}</mat-label>
            <mat-select name="rating" [(ngModel)]="applicant.rating" #rating="ngModel">
                <mat-option [value]="0">{{ 'applicant-tracker.applicants.create.noRating' | translate }}</mat-option>
                <mat-option [value]="1">1</mat-option>
                <mat-option [value]="2">2</mat-option>
                <mat-option [value]="3">3</mat-option>
                <mat-option [value]="4">4</mat-option>
                <mat-option [value]="5">5</mat-option>
            </mat-select>
            <mat-error *ngIf="rating.invalid">{{ rating.errors | formErrors }} </mat-error>
        </mat-form-field>
    </div>
</form>
